<template>
  <container-loader v-if="!isPrintersLoaded"></container-loader>
  <b-card-text v-else>
    <section v-if="mode === 'hosts'" class="printers-table">
      <disconnected-printers-list></disconnected-printers-list>
      <hosts-list></hosts-list>
    </section>
    <section v-else-if="mode === 'active'" class="printers-table">
      <disconnected-printers-list></disconnected-printers-list>
      <printers-list :printers="sortedActivePrinters"></printers-list>
    </section>
    <section v-else class="printers-table">
      <inactive-printers-list></inactive-printers-list>
    </section>
  </b-card-text>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import HostsList from './HostsList';
  import PrintersList from './PrintersList';
  import InactivePrintersList from "./InactivePrintersList";
  import DisconnectedPrintersList from "./DisconnectedPrintersList";

  import PrinterMixin from "@/mixins/printer";

  const getPrinterStatePrio = function(state) {
    switch (state) {
      case 'printing':
      case 'downloading':
      case 'heating':
        return 0;
      case 'paused': return 1;
      case 'idle': return 2;
      case 'bed_not_clear': return 3;
      case 'Virtual': return 100;
      default: return 4;
    }
  };

  const findNewestJobTime = function(jobs) {
    let max = 0;
    if (jobs && jobs.length) {
      jobs.map((job) => {
        if (job.added_to_queue_ts > max) {
          max = job.added_to_queue_ts;
        }
      })
    }
    return max;
  };

  export default {
    name: "PrintersTab",
    props: ['mode', 'search'],
    mixins: [PrinterMixin],
    components: {
      PrintersList,
      DisconnectedPrintersList,
      HostsList,
      InactivePrintersList
    },
    created() {
      this.startListenPrinterEvents();
    },
    computed: {
      ...mapGetters(['isPrintersLoaded', 'getActivePrinters', 'getJobsByPrinter']),

      sortedActivePrinters() {
        if (this.mode === 'active') {
          const search = this.search.trim().toLowerCase();
          let activePrinters = [];
          if (search.length >= 1) {
            activePrinters = this.getActivePrinters.filter(printer => {
              if ((printer.local_ip && printer.local_ip.toLowerCase().indexOf(search) >= 0) ||
                (printer.host_num && printer.host_num.toLowerCase().indexOf(this.search) >= 0) ||
                this.calculatePrinterName(printer).toLowerCase().indexOf(this.search) >= 0 ||
                printer.state.toLowerCase() === search) {
                return true;
              }
              const jobs = this.getJobsByPrinter(printer.printer_id);
              for (let i in jobs) {
                if (jobs[i].filename && jobs[i].filename.toLowerCase().indexOf(this.search) >= 0) {
                  return true;
                }
              }

              return false;
            });
          } else {
            activePrinters = this.getActivePrinters;
          }
          return activePrinters.sort((a,b) => {
            const statePrioA = getPrinterStatePrio(a.state);
            const statePrioB = getPrinterStatePrio(b.state);
            if (statePrioA === statePrioB) {
              const maxTimeA = findNewestJobTime(this.getJobsByPrinter(a.printer_id));
              const maxTimeB = findNewestJobTime(this.getJobsByPrinter(b.printer_id));
              if (maxTimeA === maxTimeB) {
                return 0;
              }
              return maxTimeA < maxTimeB ? 1 : -1;
            }

            return statePrioA < statePrioB ? -1 : 1;
          });
          //this.getActivePrinters.sort((a, b) =>  {
          //  return a.
          //})
        }

        return [];
      }
    },
    methods: {
      ...mapActions(['startListenPrinterEvents'])
    }
  }
</script>
